import type { DailyBar } from "./types";

export function normalizeDailyBar(input: {
  date: string;
  previousClose: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
}): DailyBar {
  const change = input.close - input.previousClose;
  const changeRate = (change / input.previousClose) * 100;
  return {
    date: input.date,
    previousClose: input.previousClose,
    open: input.open,
    high: input.high,
    low: input.low,
    close: input.close,
    change: Number(change.toFixed(4)),
    changeRate: Number(changeRate.toFixed(4)),
    volume: input.volume
  };
}
